import makeActionCreator from 'src/lib/makeActionCreator';
import { State } from 'src/redux/reducers/RootReducer';
import {
  ENTITIES,
  GridColumns,
  QuerbuilderPayloadColumns,
  QuerbuilderPayloadOrder,
} from 'src/models/QuerybuilderModel';
import { Preset, PRESET_TYPES } from 'src/models/PresetModel';
import { Filter, Filters } from 'src/models/AdvanceSearchModel';
import { CustomFieldsModel } from 'src/models/CustomFieldsModel';
import { FILTER_POSITION } from 'src/constants/FilterPosition';
import DEFAULT_COLUMNS from 'src/constants/columns';
import { denormalizeFilters, getOperatorAndFilters } from 'src/lib/QueryBuilderHelper';
import { getPresetsAction } from 'src/redux/actions/presetActions';
import { setSelectedPresets } from 'src/redux/actions/selectedPresetActions';
import {
  getEntitiesAction,
  setColumns,
  setFilters,
  setOrders,
} from 'src/redux/actions/querybuilderActions';
import { setAdvancedSearch } from 'src/redux/actions/advancedSearchAction';
import {
  getAccountsAction,
  getDepartmentsAction,
  getProgramsAction,
} from 'src/redux/actions/dataActions';
import { getOrganisationBankAccountAction } from 'src/redux/actions/paymentInfoAction';

export const RESET_DATAGRID_STATE = 'RESET_DATAGRID_STATE';

export const resetDatagridState = makeActionCreator(RESET_DATAGRID_STATE);

const purgeCustomfields = (filters: Filter[], customfields: CustomFieldsModel): Filter[] => (
  filters.filter((filter: Filter) => {
    const [filterEntity, field] = filter[FILTER_POSITION.field].split('.');
    if (filterEntity === ENTITIES.customfields) {
      return Object.keys(customfields).indexOf(field) !== -1;
    }
    return true;
  })
);

export const reloadDatagridForOrganisation:
(entity: ENTITIES) => ThunkedAction<State> =
  (entity: ENTITIES) => async (dispatch: any, getState: any) => {
    await dispatch(getPresetsAction({ entity }));

    const { presets, customfields } = getState();

    const layoutList = (presets[entity]?.[PRESET_TYPES.layout] ?? []) as Preset[];
    const defaultLayout = layoutList.find((preset: Preset) => preset.is_default);
    dispatch(setSelectedPresets({
      entity,
      type: PRESET_TYPES.layout,
      id: defaultLayout?.id ?? 0,
    }));
    dispatch(setColumns({
      entity,
      columns: (defaultLayout?.filter as GridColumns) || DEFAULT_COLUMNS[entity],
    } as QuerbuilderPayloadColumns));
    dispatch(setOrders({
      entity,
      order: defaultLayout?.order,
    } as QuerbuilderPayloadOrder));

    const filterList = (presets[entity]?.[PRESET_TYPES.filter] ?? []) as Preset[];
    const defaultFilter = filterList.find((preset: Preset) => preset.is_default);
    if (defaultFilter) {
      const [operator, filterRows] = getOperatorAndFilters(defaultFilter.filter as Filters);
      const purgedFilters = purgeCustomfields(filterRows as Filter[], customfields);
      dispatch(setSelectedPresets({
        entity,
        type: PRESET_TYPES.filter,
        id: defaultFilter.id,
      }));
      dispatch(setAdvancedSearch({
        entity,
        filters: {
          [operator]: purgedFilters,
        },
      }));
      dispatch(setFilters({
        entity,
        filters: {
          [operator]: denormalizeFilters([...purgedFilters]),
        },
      }));
    }

    dispatch(getAccountsAction());
    dispatch(getDepartmentsAction());
    dispatch(getProgramsAction());
    dispatch(getOrganisationBankAccountAction());
    dispatch(getEntitiesAction(entity));
  };
